// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M3 7.15V2.99C3 2.17 3.67 1.5 4.49 1.5H6.5C7.2 1.5 7.87 1.61 8.5 1.81C10.64 2.5 12.3 4.28 12.83 6.5C12.94 6.98 13 7.48 13 8V12.5C13 13.6 12.1 14.5 11 14.5H6.4M8.5 1.81V4.5C8.5 5.6 9.39 6.5 10.5 6.5H12.83',
  'M7.86 9.65L8.56 8.95C8.92 8.59 8.85 7.94 8.4 7.49C7.95 7.04 7.3 6.97 6.94 7.33L6.24 8.03L2.26 12.01C2.06 12.21 1.94 12.47 1.89 12.76L1.69 13.95C1.67 14.08 1.81 14.22 1.94 14.2L3.13 14C3.42 13.96 3.68 13.83 3.88 13.63L7.86 9.65Z',
];
